import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'auth-splash-page',
  template: `
    <img
      alt="background image"
      src="/assets/img/login-background/background-1920.webp"
      srcset="
        /assets/img/login-background/background-mobile.webp  500w,
        /assets/img/login-background/background-1000.webp   1000w,
        /assets/img/login-background/background-1400.webp   1400w,
        /assets/img/login-background/background-1920.webp   1920w
      "
    />
    <div class="col-10 col-sm-auto card d-flex flex-column rounded-4 px-5 py-4 mat-elevation-z4">
      <ng-content />
    </div>
  `,
  styles: `
    :host {
      align-items: start;
      display: grid;
      grid-template-rows: 1fr auto 2fr;
      inset: 0;
      justify-items: center;
      position: absolute;
    }

    img {
      grid-row: 1/-1;
      height: 100%;
      object-fit: cover;
      object-position: center;
      position: absolute;
      width: 100%;
    }

    .card {
      background-color: var(--sys-surface);
      grid-row: 2;
      opacity: 1;
      translate: 0 0;
      transition:
        opacity 500ms ease-in-out,
        translate 500ms ease-in-out;

      @starting-style {
        opacity: 0;
        translate: 0 -10%;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplashPageComponent {}
